"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _LinkRaw = _interopRequireDefault(require("@commerce-ui/core2/LinkRaw"));
var _RouteContext = require("@deosite/lib/RouteContext");
var _InspirationsLandingBox = _interopRequireDefault(require("@deosite/components-new/InspirationsLandingBox"));
var _langLibrary = _interopRequireDefault(require("@deosite/helpers/langLibrary"));
var _getRouteFromUrl = _interopRequireDefault(require("@deosite/helpers/getRouteFromUrl"));
var __jsx = _react["default"].createElement;
var defaultProps = {
  link: "/"
};
var ThreeInspirationBoxes = function ThreeInspirationBoxes(props) {
  var label = props.label,
    boxes = props.boxes,
    _props$link = props.link,
    link = _props$link === void 0 ? defaultProps.link : _props$link;
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  var translations = {
    showAll: (0, _langLibrary["default"])("show all")
  };
  var route = (0, _getRouteFromUrl["default"])(link);
  return __jsx(_Box["default"], {
    sx: {
      width: "100%",
      position: "relative",
      pt: ["s9", null, null, 0]
    }
  }, __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: ["column", null, null, "row"],
      flexWrap: "no-wrap",
      width: "100%",
      justifyContent: "space-between"
    }
  }, boxes.slice(0, 3).map(function (box, index) {
    return __jsx(_Box["default"], {
      sx: {
        flex: ["100%", null, null, "32%"],
        maxWidth: ["100%", null, null, "32%"],
        mt: index == 1 ? [0, null, null, "75px"] : 0,
        position: "relative",
        zIndex: 1,
        mb: ["s11", null, null, 0]
      },
      key: index + box.label
    }, __jsx(_InspirationsLandingBox["default"], {
      label: box.label,
      link: box.link,
      description: box.description,
      image: box.image
    }));
  })), __jsx(_Box["default"], {
    sx: {
      position: "absolute",
      top: ["22px", null, null, 0],
      width: "100%",
      textAlign: "center",
      zIndex: [2, null, null, "unset"]
    }
  }, __jsx(Link, {
    route: route,
    params: {
      url: link
    }
  }, __jsx(_LinkRaw["default"], {
    title: label
  }, __jsx(_Box["default"], {
    as: "span",
    sx: {
      py: "s4",
      px: "s6",
      font: "label2",
      bg: "white",
      border: "1px",
      borderColor: "main",
      borderStyle: "solid",
      color: "main"
    }
  }, label), __jsx(_Box["default"], {
    sx: {
      color: "main",
      font: "s_italic",
      mt: "s7",
      display: ["none", null, null, "block"]
    }
  }, translations.showAll)))));
};
var _default = ThreeInspirationBoxes;
exports["default"] = _default;